"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTable = void 0;
var react_1 = __importStar(require("react"));
var Table_1 = __importDefault(require("@material-ui/core/Table"));
var TableBody_1 = __importDefault(require("@material-ui/core/TableBody"));
var TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
var TableContainer_1 = __importDefault(require("@material-ui/core/TableContainer"));
var TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));
var logic_1 = require("./logic");
var DataTableButton_1 = require("./DataTableButton");
var DataTableHead_1 = require("./DataTableHead");
var DataTableRowCells_1 = require("./DataTableRowCells");
var DataTableCheckbox_1 = require("./DataTableCheckbox");
var filterRows = function (r, filterString, filterColumn) {
    return !filterString
        ? r
        : r.filter(function (row) { return row.values[filterColumn !== null && filterColumn !== void 0 ? filterColumn : 0].toLowerCase().includes(filterString.toLowerCase()); });
};
exports.DataTable = react_1.default.memo(function (_a) {
    var rows = _a.rows, columns = _a.columns, filterColumn = _a.filterColumn, filterString = _a.filterString, onButtonClicked = _a.onButtonClicked, allowedActions = _a.allowedActions, autoselect = _a.autoselect, onSelectionChanged = _a.onSelectionChanged, disableHover = _a.disableHover, onSortingChanged = _a.onSortingChanged;
    var selected = react_1.default.useRef([]);
    var _b = react_1.default.useState(false), selectedAll = _b[0], setSelectedAll = _b[1];
    var _c = react_1.default.useState(rows), sortedRows = _c[0], setSortedRows = _c[1];
    var appliedFilterString = react_1.useMemo(function () { return filterString !== null && filterString !== void 0 ? filterString : ''; }, [filterString]);
    var nRows = react_1.useMemo(function () {
        return rows.length;
    }, [rows]);
    react_1.useEffect(function () {
        var filtered = filterRows(rows, appliedFilterString, filterColumn);
        if (onSortingChanged) {
            onSortingChanged(filtered.map(function (f) { return f.id; }));
        }
        setSortedRows(filtered);
    }, [appliedFilterString, rows, filterColumn]);
    // when data changes, per default, select everything
    react_1.useEffect(function () {
        if (autoselect) {
            selected.current = rows.map(function (r) { return r.id; });
        }
    }, [rows, autoselect]);
    var handleSelectAllClick = react_1.useCallback(function (doSelect) {
        var s = doSelect ? rows.map(function (r) { return r.id; }) : [];
        selected.current = s;
        setSelectedAll(function (prev) { return !prev; });
        if (onSelectionChanged) {
            onSelectionChanged(s);
        }
    }, [onSelectionChanged, selected, rows]);
    var buttonClicked = react_1.useCallback(function (id, action) {
        if (onButtonClicked) {
            onButtonClicked(id, action);
        }
    }, [onButtonClicked]);
    var editClicked = react_1.useCallback(function (id) { return buttonClicked(id, 'edit'); }, [buttonClicked]);
    var restoreClicked = react_1.useCallback(function (id) { return buttonClicked(id, 'restore'); }, [buttonClicked]);
    var generateClicked = react_1.useCallback(function (id) { return buttonClicked(id, 'generate'); }, [buttonClicked]);
    var viewClicked = react_1.useCallback(function (id) { return buttonClicked(id, 'view'); }, [buttonClicked]);
    var deleteClicked = react_1.useCallback(function (id) { return buttonClicked(id, 'delete'); }, [buttonClicked]);
    var handleSelectClick = react_1.useCallback(function (id) {
        var selectedIndex = selected.current.indexOf(id);
        var newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected.current, id);
        }
        else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.current.slice(1));
        }
        else if (selectedIndex === selected.current.length - 1) {
            newSelected = newSelected.concat(selected.current.slice(0, -1));
        }
        else if (selectedIndex > 0) {
            newSelected = newSelected.concat(selected.current.slice(0, selectedIndex), selected.current.slice(selectedIndex + 1));
        }
        if (onSelectionChanged) {
            onSelectionChanged(newSelected);
        }
        selected.current = newSelected;
    }, [onSelectionChanged, selected]);
    var doSort = function (col, order) {
        var sRows = filterRows(logic_1.stableSort(rows, logic_1.getComparator(order === 'asc' ? 'asc' : 'desc', col, columns[col].numeric || false)), appliedFilterString, filterColumn);
        setSortedRows(sRows);
        if (onSortingChanged) {
            onSortingChanged(sRows.map(function (f) { return f.id; }));
        }
    };
    return (react_1.default.createElement(TableContainer_1.default, null,
        react_1.default.createElement(Table_1.default, null,
            react_1.default.createElement(DataTableHead_1.DataTableHead, { doSort: doSort, sortable: allowedActions === null || allowedActions === void 0 ? void 0 : allowedActions.sortable, columns: columns, onSelectAllClick: handleSelectAllClick, checkable: allowedActions === null || allowedActions === void 0 ? void 0 : allowedActions.checkable }),
            react_1.default.createElement(TableBody_1.default, null, sortedRows.map(function (row, i) { return (react_1.default.createElement(TableRow_1.default, { hover: !disableHover, key: row.id + i },
                (allowedActions === null || allowedActions === void 0 ? void 0 : allowedActions.checkable) && (react_1.default.createElement(DataTableCheckbox_1.DataTableCheckbox, { filterString: appliedFilterString, nRows: nRows, selectedAll: selectedAll, checkboxClicked: handleSelectClick, id: row.id })),
                react_1.default.createElement(DataTableRowCells_1.DataTableRowCells, { row: row, columns: columns }),
                react_1.default.createElement(TableCell_1.default, { align: "right" },
                    react_1.default.createElement(DataTableButton_1.DataTableButton, { condition: allowedActions === null || allowedActions === void 0 ? void 0 : allowedActions.editable, title: 'actions.edit', action: 'edit', onButtonClicked: editClicked, id: row.id }),
                    react_1.default.createElement(DataTableButton_1.DataTableButton, { condition: allowedActions === null || allowedActions === void 0 ? void 0 : allowedActions.restorable, title: 'actions.restore', action: 'restore', onButtonClicked: restoreClicked, id: row.id }),
                    react_1.default.createElement(DataTableButton_1.DataTableButton, { condition: allowedActions === null || allowedActions === void 0 ? void 0 : allowedActions.deletable, title: 'actions.delete', action: 'delete', onButtonClicked: deleteClicked, id: row.id }),
                    react_1.default.createElement(DataTableButton_1.DataTableButton, { condition: allowedActions === null || allowedActions === void 0 ? void 0 : allowedActions.generatable, title: 'actions.generate', action: 'generate', onButtonClicked: generateClicked, id: row.id }),
                    react_1.default.createElement(DataTableButton_1.DataTableButton, { condition: allowedActions === null || allowedActions === void 0 ? void 0 : allowedActions.viewable, title: 'actions.view', action: 'view', onButtonClicked: viewClicked, id: row.id })))); })))));
});
exports.DataTable.displayName = 'DataTable';
exports.default = exports.DataTable;
//# sourceMappingURL=DataTable.js.map